/**
 * Privilege rank of a team role, mirroring backend/src/utils/team-role.ts (isRoleDemotion).
 * OWNER > ADMIN > MANAGER > EDITOR = MEMBER > REVIEWER = VIEWER. 'CLIENT' is the pre-rename alias of REVIEWER.
 */
const TEAM_ROLE_RANK: Readonly<Record<string, number>> = {
  OWNER: 50,
  ADMIN: 40,
  MANAGER: 30,
  EDITOR: 20,
  MEMBER: 20,
  REVIEWER: 10,
  VIEWER: 10,
  CLIENT: 10,
};

const rankOf = (role: string | null | undefined): number | null => {
  if (!role) return null;
  const rank = TEAM_ROLE_RANK[role.toUpperCase()];
  return rank === undefined ? null : rank;
};

/** true only when both roles are known and `nextRole` is strictly lower than `currentRole`. */
export const isRoleDemotion = (currentRole: string | null | undefined, nextRole: string | null | undefined): boolean => {
  const current = rankOf(currentRole);
  const next = rankOf(nextRole);
  return current !== null && next !== null && next < current;
};
